export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceMailMagazineSettings: [
        {
          serviceMailMagazineId: 2,
          serviceMailMagazineUuid: "mailmagazine002",
          mailMagazineName: "メルマガ002",
          mailMagazineAddress: "aaa@aaa.com",
          deliveryType: "deliverytypemst006",
          deliveryTypeName: "警戒告知",
          noticeType: "noticeType001",
          noticeTypeName: "テキストのみ",
          keyWords: ["防災メルマガ"],
          keywordsQueryKbn: 1,
          exclusiveKeyWords: ["防災", "緊急"]
        },
        {
          serviceMailMagazineId: 1,
          serviceMailMagazineUuid: "mailmagazine001",
          mailMagazineName: "メルマガ001",
          mailMagazineAddress: "aaa@aaa.com",
          deliveryType: "deliverytypemst001",
          deliveryTypeName: "お知らせ",
          noticeType: "noticeType002",
          noticeTypeName: "画像添付",
          keyWords: ["〇〇メルマガ"],
          keywordsQueryKbn: 1,
          exclusiveKeyWords: ["地域ニュース", "〇〇メルマガ"]
        }
      ]
    }
  }
}